import { Route } from "react-router";
import Login from "../auth/login/login";
import AdminDashboard from "../mainMenu/adminDashboard";
import ProfileForm from "../pages/profile";
import { all_routes } from "./all_routes";

import AssessmentDetails from "../hrm/performance/assesments/assessmentDetails";
import AssessmentView from "../hrm/performance/assesments/assessmentView";
import Courses from "../hrm/academics/course/courses";
import CourseWiz from "../hrm/academics/course/courseWiz";
import Curriculum from "../hrm/academics/curriculum/curriculum";
import CurriculumWiz from "../hrm/academics/curriculum/curriculumWiz";
import Subjects from "../hrm/academics/subject/subjects";
import Syllabus from "../hrm/academics/syllabus/syllabus";
import ModifySyllabusDetails from "../hrm/academics/syllabus/syllabusDetails";
import Leaves from "../hrm/attendance/leaves";
import Calendar from "../hrm/calendar/calendar";
import Department from "../hrm/employees/deparment";
import Designation from "../hrm/employees/designation";
import EmployeeList from "../hrm/employees/employeesList";
import Classes from "../hrm/learning_center/class/classes";
import Students from "../hrm/learning_center/student/students";
import Timetable from "../hrm/learning_center/class/timetable";
import RolesPermissions from "../accessManagement/rolesPermissions";
import AcademicLens from "../hrm/academics/academic-lense/academicLense";
import ForgotPassword from "../auth/forgotPassword";
import OTPVerification from "../auth/otpVerification";
import ResetPassword from "../auth/resetPassword";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess";
import Tickets from "../hrm/tickets/tickets";
import TicketDetails from "../hrm/tickets/ticket-details";
import TicketGrid from "../hrm/tickets/tickets-grid";
import ChatSettings from "../settings/featureSettings/chatSettings/chat-settings";
import ChatTopupSettings from "../settings/featureSettings/chatSettings/chat-topup";
import ChatTokenUsage from "../settings/featureSettings/chatSettings/chat-token-usage";
import ChatTokenTopupHistory from "../settings/featureSettings/chatSettings/chat-token-history";
import AGTokenSettings from "../settings/featureSettings/assessmentGenerator/token-settings";
import AGTopupSettings from "../settings/featureSettings/assessmentGenerator/topup";
import AGTokenUsage from "../settings/featureSettings/assessmentGenerator/token-usage";
import AGTokenTopupHistory from "../settings/featureSettings/assessmentGenerator/token-history";
import SGTopupSettings from "../settings/featureSettings/syllabusGenerator/topup";
import SGTokenUsage from "../settings/featureSettings/syllabusGenerator/token-usage";
import SGTokenTopupHistory from "../settings/featureSettings/syllabusGenerator/token-history";
import SGTokenSettings from "../settings/featureSettings/syllabusGenerator/token-settings";
import StorageUsage from "../settings/featureSettings/storage/storage-usage";
import Attendance from "../hrm/attendance/attendance";
import FeatureControl from "../settings/systemSettings/application/featureControl";
import CloudStorageSettings from "../settings/systemSettings/websiteSettings/cloudStorageSettings";
import LearningCenter from "../settings/systemSettings/websiteSettings/contactDetails";
import CourseSettings from "../settings/systemSettings/websiteSettings/courseSettings";
import Subscriptions from "../hrm/online-learning-center/subscriptions/subscriptions";
import UserSubscriptions from "../hrm/online-learning-center/user-subscriptions/userSubscriptions";
import Payments from "../hrm/online-learning-center/transactions/payments";
import TaxSettings from "../settings/systemSettings/billingSettings/taxSettings";
import RichTextAssessmentDetails from "../hrm/performance/assesments/ritchTextAsessmentDetails";

const routes = all_routes;

export const privateRoutes = [
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
  },

  // pages

  {
    path: routes.profile,
    element: <ProfileForm />,
  },

  //Application

  {
    path: routes.holidays,
    element: <Calendar />,
    route: Route,
  },

  {
    path: routes.employeeList,
    element: <EmployeeList />,
    route: Route,
  },

  {
    path: routes.departments,
    element: <Department />,
    route: Route,
  },
  {
    path: routes.designations,
    element: <Designation />,
    route: Route,
  },
  {
    path: routes.academiclens,
    element: <AcademicLens />,
    route: Route,
  },
  {
    path: routes.curriculum,
    element: <Curriculum />,
    route: Route,
  },
  {
    path: routes.courses,
    element: <Courses />,
    route: Route,
  },
  {
    path: routes.subjects,
    element: <Subjects />,
    route: Route,
  },
  {
    path: routes.syllabus,
    element: <Syllabus />,
    route: Route,
  },
  {
    path: routes.syllabusdetails,
    element: <ModifySyllabusDetails />,
    route: Route,
  },
  {
    path: routes.curriculumAcademicWiz,
    element: <CurriculumWiz />,
    route: Route,
  },
  {
    path: routes.courseAcademicWiz,
    element: <CourseWiz />,
    route: Route,
  },
  {
    path: routes.class,
    element: <Classes />,
    route: Route,
  },
  {
    path: routes.students,
    element: <Students />,
    route: Route,
  },

  {
    path: routes.timetable,
    element: <Timetable />,
    route: Route,
  },

  {
    path: routes.leaveadmin,
    element: <Leaves />,
    route: Route,
  },
    {
    path: routes.attendance,
    element: <Attendance />,
    route: Route,
  },
  {
    path: routes.assessments,
    element: <AssessmentView />,
    route: Route,
  },
  {
    path: routes.assessment_questions,
    element: <RichTextAssessmentDetails />,
    route: Route,
  },
  {
    path: routes.rolesPermissions,
    element: <RolesPermissions />,
  },
  {
    path: routes.tickets,
    element: <Tickets />,
  },
  {
    path: `${routes.ticketDetails}/:id`,
    element: <TicketDetails />,
  },
  {
    path: routes.ticketGrid,
    element: <TicketGrid />,
  },

  {
    path: routes.chatSettings,
    element: <ChatSettings />,
  },
  {
    path: routes.chatTopupSettings,
    element: <ChatTopupSettings />,
  },
  {
    path: routes.chatTokenUsage,
    element: <ChatTokenUsage />,
  },
    {
    path: routes.chatTopupHistory,
    element: <ChatTokenTopupHistory />,
  },
  {
    path: routes.agSettings,
    element: <AGTokenSettings />,
  },
  {
    path: routes.agTopupSettings,
    element: <AGTopupSettings />,
  },
  {
    path: routes.agTokenUsage,
    element: <AGTokenUsage />,
  },
  {
    path: routes.agTopupHistory,
    element: <AGTokenTopupHistory />,
  },
  {
    path: routes.sgSettings,
    element: <SGTokenSettings />,
  },
  {
    path: routes.sgTopupSettings,
    element: <SGTopupSettings />,
  },
  {
    path: routes.sgTokenUsage,
    element: <SGTokenUsage />,
  },
  {
    path: routes.sgTopupHistory,
    element: <SGTokenTopupHistory />,
  },
  {
    path: routes.storageSettings,
    element: <StorageUsage />,
  },
  {
    path: routes.storageUsage,
    element: <StorageUsage />,
  },
  {
    path: routes.featureControl,
    element: <FeatureControl />,
  },
  {
    path: routes.cloudStorageSettings,
    element: <CloudStorageSettings />,
  },
  {
    path: routes.learningCenter,
    element: <LearningCenter />,
  },
  {
    path: routes.courseSetting,
    element: <CourseSettings />,
  },
  {
    path: routes.taxSettings,
    element: <TaxSettings />,
  },
  {
    path: routes.subscriptions,
    element: <Subscriptions />,
  },
  {
    path: routes.userSubscriptions,
    element: <UserSubscriptions />,
  },
  {
    path: routes.paymentTransactions,
    element: <Payments />,
  }
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.otpVerification,
    element: <OTPVerification />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
    route: Route,
  },
];
